import { render, staticRenderFns } from "./AGBs.vue?vue&type=template&id=7c3b4702&scoped=true&"
import script from "./AGBs.vue?vue&type=script&lang=js&"
export * from "./AGBs.vue?vue&type=script&lang=js&"
import style0 from "./AGBs.vue?vue&type=style&index=0&id=7c3b4702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3b4702",
  null
  
)

export default component.exports